import React from 'react';
import { OverlayProps } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

interface StandardTooltipProps {
  text: string;
  placement?: OverlayProps['placement'];
  children: JSX.Element;
}

const StandardTooltip = ({
  text,
  children,
  ...props
}: StandardTooltipProps) => {
  return (
    <>
      {text ? (
        <OverlayTrigger
          placement={props.placement || 'bottom'}
          overlay={<Tooltip id="standard-tooltip">{text}</Tooltip>}
          {...props}
        >
          {children}
        </OverlayTrigger>
      ) : (
        children
      )}
    </>
  );
};

export default StandardTooltip;
